import { render, staticRenderFns } from "./AcademicRecordsForm.vue?vue&type=template&id=f480c842&scoped=true"
import script from "./AcademicRecordsForm.vue?vue&type=script&lang=js"
export * from "./AcademicRecordsForm.vue?vue&type=script&lang=js"
import style0 from "./AcademicRecordsForm.vue?vue&type=style&index=0&id=f480c842&prod&lang=scss&scoped=true"
import style1 from "./AcademicRecordsForm.vue?vue&type=style&index=1&id=f480c842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_cache-loader@4.1.0_webpack@4.47.0__css-load_359e2a22b61d78988ed9bf0e7b495bd0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f480c842",
  null
  
)

export default component.exports